import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { COLOR_SET_CLASSES, customTV } from '../../utils/tailwind';
import { Icon } from '../Icon/Icon';
import { CircularLoader } from '../Loader/CircularLoader';
import { DEFAULT_SIZE } from './styles';
export const ICON_SIZES = {
    48: 20,
    40: 16,
    32: 14,
    24: 12,
};
const { 'interactive.primary': primary, 'interactive.secondary': secondary, 'interactive.critical': critical, 'interactive.primary.disabled': disabled, default: defaultColorSet, } = COLOR_SET_CLASSES;
const icon = customTV({
    variants: {
        disabled: { true: disabled.default.icon },
        hasColor: { true: undefined },
        variant: {
            contrast: undefined,
            critical: undefined,
            primary: undefined,
            secondary: undefined,
            text: undefined,
            alternativeText: undefined,
        },
    },
    compoundVariants: [
        {
            disabled: false,
            hasColor: false,
            variant: 'contrast',
            className: defaultColorSet.default.icon,
        },
        {
            disabled: false,
            hasColor: false,
            variant: 'critical',
            className: critical.default.icon,
        },
        {
            disabled: false,
            hasColor: false,
            variant: 'primary',
            className: primary.default.icon,
        },
        {
            disabled: false,
            hasColor: false,
            variant: 'secondary',
            className: secondary.default.icon,
        },
        {
            disabled: false,
            hasColor: false,
            variant: 'text',
            className: secondary.default.icon,
        },
    ],
});
export const ButtonInner = ({ children, color, disabled = false, endIcon, loading, size = DEFAULT_SIZE, startIcon, variant }) => {
    const iconSize = ICON_SIZES[size];
    if (loading) {
        return _jsx(CircularLoader, { size: iconSize, colorSet: "interactive.secondary.disabled" });
    }
    return (_jsxs(_Fragment, { children: [startIcon && (_jsx(Icon, { className: icon({
                    disabled,
                    hasColor: !!color,
                    variant,
                    className: [children ? 'mr-8' : undefined],
                }), name: startIcon, color: disabled ? undefined : color, size: iconSize })), children, endIcon && (_jsx(Icon, { className: icon({
                    disabled,
                    hasColor: !!color,
                    variant,
                    className: [children ? 'ml-8' : undefined],
                }), name: endIcon, color: disabled ? undefined : color, size: iconSize }))] }));
};
